const labels = {
    en: {
        consumerLabel: 'consumer',
        businessSMELabel: 'business: SME',
        businessLabel: 'business',
        hotlinkLabel: 'hotlink',
        orderTrackerLabel: 'order tracker',
        mbhLoginLabel: 'Maxis Business Hub login',
        mobilePlansLabel: 'MOBILE PLANS',
        broadbandLabel: 'BROADBAND',
        devicesLabel: 'DEVICES',
        searchLabel: 'search',
        trendingSearchLabel: 'Trending Searches',
        promotionSearchLabel: 'Promotions',
        suggestedSearches: 'Suggested searches',
        smeLabel: 'SME',
        corporateLabel: 'Corporate'
    },
    ms: {}
};
export default labels;
